import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ListHeader } from "./Components/ListHeader";
import MainMenu from './Components/MainMenu';
import { BrowserView, isTablet, MobileView } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserGraduate } from '@fortawesome/free-solid-svg-icons'
import logoPartner from './Images/Logo/Redinet-Web-Partner.webp';
import logoPartnerMobile from './Images/Logo/Redinet-Web-Partner-mobile.webp';
import logoAliado from './Images/Logo/Redinet-Web-Aliado.webp';
import logoAliadoMobile from './Images/Logo/Redinet-Web-Partner-mobile.webp';
import logoAliadoMobileWhite from './Images/Logo/Redinet-Web-Aliado-mobileW.webp';
import logoPartnerMobileWhite from './Images/Logo/Redinet-Web-PartnerW.webp';

import ResponsiveImage from './Components/ResponsiveImage';

const logo = 'https://cdn.redinet.us/LogoRedinet.webp';
const logoIWS = 'https://cdn.redinet.us/Logo IWS2.webp';
const logoRDCR = 'https://cdn.redinet.us/Redinet_CR.webp';
const logoRDMX = 'https://cdn.redinet.us/Redinet_MX.webp';
const logoRDPE = 'https://cdn.redinet.us/Redinet_PE.webp';
const logoSolo = 'https://cdn.redinet.us/Redinet_Solo.webp';
const logoLatWhite = 'https://cdn.redinet.us/Redinet_Lat-01.webp'
const plecaMenu = 'https://cdn.redinet.us/Plecas_sombra_desktop.webp';
const plecaMobile = 'https://cdn.redinet.us/Pleca_sombra_mobile.webp';


export function Header() {
  const location = useLocation();
  const [headerClassName, setHeaderClassName] = useState('');

  // Definir las rutas donde quieres que el icono aparezca azul desde el inicio
  const rutasConIconoAzul = ['/portal-web', '/Dynamics', '/power-apps', '/TeamViewer'];

  // Verificar si la ruta actual está en el array
  const esMostrarIconoAzul = rutasConIconoAzul.includes(location.pathname);

  const handleScroll = (headerClassName) => {

    if (headerClassName !== 'menuscroll' && window.pageYOffset >= 100) {
      setHeaderClassName(window.pageYOffset);

    } else if (headerClassName === 'menuscroll' && window.pageYOffset < 100) {
      setHeaderClassName('');

    }
  }


  React.useEffect(() => {
    window.onscroll = () => handleScroll(headerClassName);
  }, [headerClassName]); // IMPORTANT, This will cause react to update depending on change of this value


  const iconBar = {
    xmlns: "http://www.w3.org/2000/svg",
    ancho: "22",
    alto: "22",
    currentColor: "currentColor",
    clase: "bi bi-list",
    viewCaja: "0 0 16 16",
    d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"

  };
  const domainName = window.location.hostname;

  return (
    <nav className="navbar navbar-expand-lg mb-5 Principal-header">

      <div className="container-fluid header-new-design">

        <BrowserView className="w-100">
          <ListHeader />
        </BrowserView>

        <MobileView className="menu-header-mb">

          {isTablet ? <ListHeader /> : headerClassName > 200 || esMostrarIconoAzul ?
            <Link className="nav-brand-mobile" to="/">
              {/* <img src={domainName.includes('redinet.com.mx') ? logoRDMX : domainName.includes('redinet.us') ? logoSolo : domainName.includes('redinet.cr') ? logoRDCR : domainName.includes('redinet.pe') ? logoRDPE : domainName.includes('iwsservices.ca') ? logoIWS : logo} alt="LogoIWS" className="d-inline-block align-text-top d-none d-md-block logo-mobile" />
              <img src={domainName.includes('redinet.com.mx') ? logoRDMX : domainName.includes('redinet.us') ? logoSolo : domainName.includes('redinet.cr') ? logoRDCR : domainName.includes('redinet.pe') ? logoRDPE : domainName.includes('iwsservices.ca') ? logoIWS : logo} alt="LogoIWS" className="d-inline-block align-text-top d-block d-md-none logo-mobile" /> */}
              {(() => {
                // Si el dominio es redinet.us usamos logoPartner, en cualquier otro caso usamos logoAliado
                const isPartner = domainName.includes('redinet.us');
                const desktopLogo = isPartner ? logoPartner : logoAliado;
                const mobileLogo = isPartner ? logoPartnerMobile : logoAliadoMobile;
                const altText = isPartner ? 'Logo Redinet Partner' : 'Logo Redinet Aliado';
                return (
                  <ResponsiveImage
                    desktopSrc={mobileLogo}
                    mobileSrc={mobileLogo}
                    alt={altText}
                    className="d-inline-block align-text-top d-block d-md-none logo-mobile"
                  />
                )
              })()}
            </Link> :

            <Link className="navbar-brand" to="/">
              {/* <img src={domainName.includes('redinet.com.mx') ? logoRDMX : domainName.includes('redinet.us') ? logoSolo : domainName.includes('redinet.cr') ? logoRDCR : domainName.includes('redinet.pe') ? logoRDPE : domainName.includes('iwsservices.ca') ? logoIWS : logoLatWhite} alt="LogoIWS" className="logowhite-mobile d-inline-block align-text-top d-none d-md-block logo-mobile" />
              <img src={domainName.includes('redinet.com.mx') ? logoRDMX : domainName.includes('redinet.us') ? logoSolo : domainName.includes('redinet.cr') ? logoRDCR : domainName.includes('redinet.pe') ? logoRDPE : domainName.includes('iwsservices.ca') ? logoIWS : logoLatWhite} alt="LogoIWS" className="logowhite-mobile d-inline-block align-text-top d-block d-md-none logo-mobile" /> */}
              {(() => {
                // Si el dominio es redinet.us usamos logoPartner, en cualquier otro caso usamos logoAliado
                const isPartner = domainName.includes('redinet.us');
                const desktopLogo = isPartner ? logoPartner : logoAliado;
                const mobileLogo = isPartner ? logoPartnerMobileWhite : logoAliadoMobileWhite;
                const altText = isPartner ? 'Logo Redinet Partner' : 'Logo Redinet Aliado';
                return (
                  <ResponsiveImage
                    desktopSrc={mobileLogo}
                    mobileSrc={mobileLogo}
                    alt={altText}
                    className="d-inline-block align-text-top d-block d-md-none logo-mobile"
                  />
                )
              })()}
            </Link>}



          <div className="divIcon">
            <a href="https://academy.redinet.us/">

              {headerClassName > 200 || esMostrarIconoAzul ?
                // <SchoolIcon className="iconPersonBlue" color="blue"></SchoolIcon> : 
                // <SchoolIcon className="iconPerson"></SchoolIcon>
                <FontAwesomeIcon className="iconPersonBlue" icon={faUserGraduate} /> :
                <FontAwesomeIcon className="iconPerson" icon={faUserGraduate} />
              }
            </a>

          </div>
          <MainMenu scroll={headerClassName} className="colorMenu" />
        </MobileView>

        {/* <button className="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarSupportedContent" 
            aria-controls="navbarSupportedContent" 
            aria-expanded="false" aria-label="Toggle navigation"
            >
            <SVG xmlns={iconBar.xmlns} ancho={iconBar.ancho} alto={iconBar.alto} currentColor={iconBar.currentColor} clase={iconBar.clase}
              viewCaja={iconBar.viewCaja} d={iconBar.d} />
          </button> */}


      </div>
      <div>
        <BrowserView>
          <div className="pleca-menu">
            <img src={plecaMenu} alt="Pleca menú" />
          </div>
        </BrowserView>
        <MobileView >
          <div className="pleca-menu-mobile">
            {headerClassName > 200 || esMostrarIconoAzul ? <img src={plecaMobile} alt="Pleca menú" className="show-pleca" /> : ""}
          </div>
        </MobileView>
      </div>


    </nav>
  )
}